import { render, staticRenderFns } from "./BoardSearch.vue?vue&type=template&id=28196b52&scoped=true&"
import script from "./BoardSearch.vue?vue&type=script&lang=js&"
export * from "./BoardSearch.vue?vue&type=script&lang=js&"
import style0 from "./BoardSearch.vue?vue&type=style&index=0&id=28196b52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28196b52",
  null
  
)

export default component.exports